'use strict';

import cf7Helpers from '../../../src/js/shared/cf7Helpers';
import numberCounter from '../../../src/js/shared/numberCounter';

const $ = jQuery.noConflict();
$(function() {
	const contactBlock = {
		init: function() {
			cf7Helpers.afterFormSubmit();
			cf7Helpers.preventNumTelInputsTypeLetters();
			numberCounter.init();
		},
	};
	contactBlock.init();
});
